import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import {
  fetchPodcastsListings,
  podcastsListingsSelector,
} from '../../../LandingPage/LandingPage.duck';
import { useDispatch, useSelector } from 'react-redux';
import { CarouselSection, IconCollection } from '../../../../components';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { LISTING_TYPE_PODCASTS } from '../../../../constants';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../../../util/routes';
import { getListingEmptyCardData } from '../listingEmptyCardData';

const PodcastsSection = ({ sectionName, description, currentUser }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const podcastsListings = useSelector(podcastsListingsSelector);

  useEffect(() => {
    dispatch(fetchPodcastsListings());
  }, []);

  const showMorePodcasts = () => {
    history.push(createResourceLocatorString('PodcastsPage', routeConfiguration, {}));
  };

  const emptyCardData = getListingEmptyCardData({
    currentUser,
    listings: podcastsListings,
    listingType: LISTING_TYPE_PODCASTS,
    icon: <IconCollection icon="icon-podcast" />,
    intl,
    defaultTitleId: 'ListingEmptyCard.podcastsTitle',
    defaultTextId: 'ListingEmptyCard.podcastsText',
  });

  return podcastsListings?.length ? (
    <CarouselSection
      name={sectionName}
      description={description}
      items={podcastsListings}
      handleAction={showMorePodcasts}
      emptyCardData={emptyCardData}
    />
  ) : null;
};

export default PodcastsSection;
